import styles from "./login.module.css";
import "../../assets/fonts/fonts.css"
import React, {useEffect, useRef, useState} from "react";
import {useNavigate} from "react-router-dom";
import Routes from "../../assets/Routes/Routes";
import Inputmask from "inputmask";
import ServerRequest from "../../serverRequests/ServerRequest";
import texts from "../../assets/ContextProvider/textsLocalized.json";
// import Loader from "../../components/Loader/Loader";
import {ReactComponent as Logo} from "../../components/Header/img/cinemAI-logo.svg";
import {animateButtonPress} from "../../assets/AdditionalFunctions/AnimateButtonPress";

const Login = () => {
  let linkToLp = "https://clnemailands.com/lp1/";

  const inputRef = useRef(null);
  const refLoginSection = useRef(null);
  const navigate = useNavigate();
  const [isAuthorized, setIsAuthorized] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");
  const [isSubscriptionError, setIsSubscriptionError] = useState(false);
  const btnRef = useRef(null);

  useEffect(() => {
    Inputmask({
      mask: "6\\9 999-999-99",
      placeholder: " ", // ← Забирає підкреслення
      showMaskOnHover: false,
      showMaskOnFocus: true,
      showMaskOnBlur: false,
    }).mask(inputRef.current);
  }, []);


  let handleSubmit = async () => {
    await animateButtonPress(btnRef, styles.pressed);

    if (inputRef.current) {
      const phoneNumber = inputRef.current.value.replace(/\D/g, ""); // Видаляємо всі нецифрові символи
      // console.log(phoneNumber)

      if (phoneNumber && phoneNumber.length === 10) {
        localStorage.setItem("userPhone", phoneNumber);

        // DEV MOCK: bypass server auth for any number
        // localStorage.setItem("generatedAttemptsDaily", "10");
        // localStorage.setItem("userHash", "dev-mock-hash");
        // redirectToWelcomePage();

        // PRODUCTION: uncomment below and remove the mock above
        let serverData = await ServerRequest.authenticateUserData(phoneNumber);
        let parsedServerData = await serverData.json();
        if (serverData.ok) {
          if (parsedServerData.code === 200) {
            if (parsedServerData['generation_attempts'] !== null) {
              localStorage.setItem("generatedAttemptsDaily", parsedServerData['generation_attempts']);
            }
            localStorage.setItem("userHash", parsedServerData['user_hash']);
            redirectToWelcomePage();
          }
        } else if (parsedServerData.code === 401) {
          setIsAuthorized(false);
          setIsSubscriptionError(true);
          setErrorMessage(texts.login["subscription-first-part"]);
        }
      } else {
        setIsAuthorized(false);
        setErrorMessage(texts.login['invalid-number']);
      }
    }
  };


  const applyInputMask = () => {
    setErrorMessage('');
    setIsAuthorized(true);
    setIsSubscriptionError(false);
  };


  const redirectToWelcomePage = () => {
    navigate(Routes.welcome);
  };


  // only for test resetAttemptsForUniqueUser, must be commented on production
  const resetAttemptsForUniqueUser = async () => {
    let userHash = localStorage.getItem("userHash") ?? null;

    await fetch("https://api.movie-aidea.com/api/reset-attempts", {
      method: "POST",
      headers: {"Content-Type": "application/json"},
      body: JSON.stringify({user_hash: userHash}),
    });
  }


  return (
    <section ref={refLoginSection}
             className={styles["section_wrapper"]}>

      {/*temporary_reset_btn below is not for production, only for test*/}
      <button className={styles['temporary_reset_btn']}
              onClick={resetAttemptsForUniqueUser}>
        Reset attempts
      </button>
      {/*temporary_reset_btn above is not for production, only for test*/}

      <div className={styles.auth__page}>
        <Logo className={styles["main-logo"]}
              width={181}
              height={40}/>
        <img className={
          isAuthorized ? `${styles["auth__logo"]}`
            :
            `${styles["auth__logo-warning"]}`}
             src={
               isAuthorized ?
                 require("./img/img-registration.png")
                 :
                 require("./img/img-registration-error.png")}
             alt="auth__logo"
        />
        <div id="auth__text" className={styles["auth__page_text"]}>
          {texts.login['title']}
        </div>
        <input
          ref={inputRef}
          onFocus={applyInputMask}
          className={`${styles['auth__number']} ${!isAuthorized && styles.error}`}
          id="phoneNumber"
          type="tel"
          placeholder={texts.login['placeholder-text']}
          inputMode="numeric"
          autoComplete="off"
          autoCorrect="off"
          autoCapitalize="off"
          spellCheck="false"
        />
        <div className={styles['error__box']}>
          {isSubscriptionError ? (
            <>
              {texts.login["subscription-first-part"]}
              <a href={linkToLp} style={{textDecoration: "underline", color: "inherit"}}>
                {texts.login["subscription-second-part"]}
              </a>
              {" "}{texts.login["subscription-third-part"]}
            </>
          ) : errorMessage}
        </div>
        <button ref={btnRef}
          className={styles['auth__page_button']}
                onClick={handleSubmit}>
          {texts.login["button"]}
        </button>
      </div>
    </section>
  );
};

export default Login;
